import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Table from "../../components/Table";
import {
    Box,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography,
} from "@mui/material";
export const OptionsConfig = ({ options, setOptions }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [newLabel, setNewLabel] = useState("");
    const [newIcon, setNewIcon] = useState("");
    const [optionsTableData, setOptionsTableData] = useState([]);

    useEffect(() => {
        const data = Object.entries(options).map(([label, icon]) => ({
            label,
            icon,
        }));
        setOptionsTableData(data);
    }, [options]);

    const optionsColumns = [
        {
            name: "Label",
            selector: (row) => row.label,
            sortable: true,
        },
        {
            name: "Icon",
            cell: (row) => <FontAwesomeIcon color="primary" icon={`fa-${row.icon}`} />,
        },
        {
            name: "Actions",
            cell: (row) => (
                <Button
                    color="error"
                    onClick={() => handleDeleteOption(row.label)}
                    size="small"
                    variant="contained"
                >
                    Delete
                </Button>
            ),
        },
    ];

    const handleOptionUpdates = () => {
        if (!newLabel.trim() || !newIcon.trim()) return;
        const updatedOptions = {
            ...options,
            [newLabel]: newIcon,
        };
        setOptions(updatedOptions);
        setDialogOpen(false);
        setNewLabel("");
        setNewIcon("");
    };

    const handleDeleteOption = (label) => {
        if (window.confirm(`Are you sure you want to delete "${label}"?`)) {
            const updatedOptions = { ...options };
            delete updatedOptions[label];
            setOptions(updatedOptions);
        }
    };

    return (
        <Box sx={{ position: "relative" }}>
            <Paper sx={{ maxWidth: 600, mb: 2 }}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 2,
                    }}
                >
                    <Typography variant="h6">Configuration Options</Typography>
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={() => setDialogOpen(true)}
                        sx={{ ml: 2 }}
                    >
                        Add Option
                    </Button>
                </Box>
                <Table
                    columns={optionsColumns}
                    data={optionsTableData}
                    pagination={false}
                    pointerOnHover
                    highlightOnHover
                />
            </Paper>

            <Dialog
                open={dialogOpen}
                onClose={() => {
                    setDialogOpen(false);
                    setNewLabel("");
                    setNewIcon("");
                }}
            >
                <DialogTitle>Add New Option</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Label"
                        fullWidth
                        value={newLabel}
                        onChange={(e) => setNewLabel(e.target.value)}
                    />
                    <TextField
                        margin="dense"
                        label="Icon (FontAwesome name)"
                        fullWidth
                        value={newIcon}
                        onChange={(e) => setNewIcon(e.target.value)}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <span style={{ color: "#888", marginRight: 4 }}>fa-</span>
                                ),
                            },
                        }}
                    />
                    <Box sx={{ mt: 2 }}>
                        <a
                            href="https://fontawesome.com/search?f=classic&s=solid&ic=free&o=r"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "underline", color: "#1976d2" }}
                        >
                            Get Icon code here
                        </a>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
                    <Button onClick={handleOptionUpdates} variant="contained">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};
